import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import Close from "@material-ui/icons/Close";
import { I18n } from "@aws-amplify/core";
import { get } from "lodash";

import images from "../../assets/img/images";
import { fetchPost, fetchGet } from "../../api/fetch";

const styles = {
  scanProduct: {
    width: "100%",
    maxWidth: "360px",
    height: "640px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    border: "1px solid #dddddd",
    padding: "16px 8px 12px",
    '@media(max-width: 470px)': {
      height: "640px",
    }
  },
  scanProductNav: {
    width: "100%",
    backgroundColor: "white",
    display: "grid",
    gridTemplateColumns: "1fr 24px",
    alignItems: "center",
    marginBottom: "12px"
  },
  vmiLocation: {
    fontSize: "16px",
    color: "#5f00a0",
    fontWeight: "500",
    paddingLeft: "4px",
    cursor: "pointer",
  },
  mainTitle: {
    placeSelf: "center",
    fontSize: "14px",
    width: "100%",
    paddingLeft: "4px",
    paddingBottom: "16px",
    borderBottom: "1px solid rgba(0, 0, 0, 0.26)",
    color: "#5f00a0",
    display: "flex",
    alignItems: "center",
  },
  closeButtonContainer: {
    placeSelf: "center",
    width: "24px",
    height: "24px",
    "&:hover": {
      backgroundColor: "#f2f9fa",
      borderRadius: "2px",
      cursor: "pointer",
    }
  },
  closeButton: {
    placeSelf: "center",
  },
  // Breadcrumbs
  breadcrumbItem: {
    display: "flex",
    alignItems: "center"
  },
  breadcrumbLink: {
    cursor: 'pointer',
  },
  breadcrumbItemLast: {
    color: "rgba(0,0,0,0.54)"
  },
  breadcrumbIcon: {
    margin: "0 8px",
  },
  // Rows
  resultContainer: {
    width: "100%",
  },
  errorMessage: {
    width: "100%",
    textAlign: "center",
    color: "#eb3c39",
    marginTop: "16px",
  },
  zoneRow: {
    minHeight: "46px",
    width: "100%",
    display: "flex",
    padding: "9px 8px",
    alignItems: "center",
    borderBottom: "1px solid rgba(0, 0, 0, 0.26)",
    boxSizing: "border-box",
    cursor: "pointer",
  },
  zoneRowLast: {
    borderBottom: "2px solid rgba(0, 0, 0, 1)",
    marginBottom: "8px"
  },
  rowDescription: {
    maxWidth: "272px"
  },
  zoneContainer: {
    height: "28px",
    minWidth: "28px",
    border: "1px solid black",
    borderRadius: "2px",
    marginRight: "8px",
    textAlign: "center",
    padding: "4px 2px",
  },
  disabled: {
    pointerEvents: "none",
  },
  disabledContainer: {
    color: "rgba(0,0,0,0.54)",
    border: "1px solid rgba(0,0,0,0.54)",
  }
};

const MobileVmiZones = (props) => {
  const { classes, language } = props;

  const [zoneId, setZoneId] = React.useState()
  const [resultsAssociated, setResultAssociated] = React.useState([])
  const [resultsChildren, setResultChildren] = React.useState([])
  const [productLocationBreadcrumbs, setProductLocationBreadcrumbs] = React.useState("")
  const [productLocationBreadcrumbsIds, setProductLocationBreadcrumbsIds] = React.useState([])
  const [scanError, setScanError] = React.useState("")

  React.useEffect(() => {
    setZoneId(props.selectedZoneId)
    console.log(zoneId)
    const body = {
      "zone": props.selectedZoneId
    }

    try {
      fetchPost("vmi/zones/search", body)
        .then(res => {
          console.log(res)
          if (res.assigned) {
            setResultAssociated(res.items)
            setResultChildren(res.childs)
            setProductLocationBreadcrumbs(res.assigned.path)
            setProductLocationBreadcrumbsIds(res.assigned.ids.split(" > "))

            props.setSelectedZoneId(0)

          } else {
            setScanError(I18n.get("invalid_pzi"))
          }
        })
        .catch(e => {
          console.error(e)
        })
    } catch (e) {
      console.log(e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handleSelectProduct = (id, zoneId, orqId, pziId) => {
    if (orqId) {
      fetchGet(`order_request/${orqId}`)
        .then(orderRequest => {
          orderRequest["order_request_id"] = orderRequest["id"]
          orderRequest["order_request_quantity"] = orderRequest["quantity"]
          orderRequest["order_request_units"] = orderRequest["unit_of_measurement"]
          props.setOpenZone(false)
          props.setSelectedProductData({ id, orderRequest, zoneId, pziId })
          props.setOpenRequest(true)
        })
    } else {
      props.setOpenZone(false)
      props.setSelectedProductData({ id, orderRequest: null, zoneId, pziId })
      props.setOpenRequest(true)
    }
  }
  const handleBreadcrumb = zoneId => {
    const body = {
      "zone": zoneId
    }

    try {
      fetchPost("vmi/zones/search", body)
        .then(res => {
          setResultAssociated(res.items)
          setResultChildren(res.childs)
          setProductLocationBreadcrumbs(res.assigned.path)
          setProductLocationBreadcrumbsIds(res.assigned.ids.split(" > "))

          props.setSelectedZoneId(0)

        })
        .catch(e => {
          console.error(e)
        })
    } catch (e) {
      console.log(e);
    }
  }
  const generateBreadcrumbs = () => {
    return productLocationBreadcrumbs.split(" > ").slice(1).map((item, i) => {
      if (i < (productLocationBreadcrumbs.split(" > ").slice(1).length - 1)) {
        return <span className={classes.breadcrumbItem} key={`bc-item-${i}`}>
          <span className={classes.breadcrumbLink} onClick={() => handleBreadcrumb(productLocationBreadcrumbsIds.slice(1)[i])}>{item}</span>
          <img src={images.breadcrumbIconBlack} height="12px" alt=">" className={classes.breadcrumbIcon} />
        </span>
      } else {
        return <span className={classes.breadcrumbItemLast} key={`bc-item-${i}`}>{item}</span>
      }
    })
  }

  return (
    (<div className={classes.scanProduct}>
      <div className={classes.scanProductNav}>
        <div className={classes.vmiLocation} onClick={() => handleBreadcrumb(productLocationBreadcrumbsIds[0])}>{productLocationBreadcrumbs.split(" > ")[0]}</div>
        <div className={classes.closeButtonContainer}>
          <Close className={classes.closeButton}
            onClick={() => props.setOpenZone(false)} />
        </div>
      </div>
      <div className={classes.mainTitle}>
        {generateBreadcrumbs()}
      </div>
      <div className={classes.resultContainer}>
        {scanError ? <div className={classes.errorMessage}>{scanError}</div> : null}
        {resultsAssociated.map((p, i) =>
          <div className={`${classes.zoneRow} ${i === (resultsAssociated.length - 1) ? classes.zoneRowLast : ""}`} key={`zone-product-${i}`} onClick={() => handleSelectProduct(p.product_id, p.zone_id, p.order_request_id, p.pzi_id)}>
            <div className={classes.rowDescription}>{language === 'en' ? p.description_en : p.description_fr}</div>
          </div>
        )}
        {resultsChildren.map((p, i) =>
          <div className={`${classes.zoneRow} ${p.child_count === 0 ? classes.disabled : ""}`} key={`zone-product-${i}`} onClick={() => p.child_count ? handleBreadcrumb(p.zone_id) : handleSelectProduct(p.product_id, p.zone_id, p.order_request_id, p.pzi_id)}>
            <div className={`${classes.zoneContainer} ${p.child_count === 0 ? classes.disabledContainer : ""}`}>{p.zone_name}</div>
            <div className={classes.rowDescription}>{p.child_count ? `(${p.child_count})` : (language === 'en' ? p.description_en : p.description_fr)}</div>
          </div>
        )}
      </div>
    </div>)
  );
};

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
    companies: get(state, ["companies"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(MobileVmiZones))
);

